import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("ts_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("ts_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ts_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signupTeacher = async (payload) => {
    const { data } = await api.post("/auth/signup/teacher", payload);
    localStorage.setItem("ts_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signupStudent = async (payload) => {
    const { data } = await api.post("/auth/signup/student", payload);
    localStorage.setItem("ts_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signupParent = async (payload) => {
    const { data } = await api.post("/parent/signup", payload);
    localStorage.setItem("ts_token", data.token);
    setUser(data.user);
    return { user: data.user, linked_children: data.linked_children };
  };

  const signupInstitute = async (payload) => {
    const { data } = await api.post("/institute/signup", payload);
    localStorage.setItem("ts_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ts_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signupTeacher, signupStudent, signupParent, signupInstitute, logout, refreshMe, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
